
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }

  Flits(document).on('Flits:SocialLogin:Loaded',function(event){
    event.detail.settings['social_login_or_html'] = `<div class="flits-or"><hr><span>OR</span><hr></div>`;
    event.detail.settings['social_login_continue_html'] = `<div class="flits-continue"><hr><span>Continue With</span><hr></div>`;
  })
  
  Flits(document).on('Flits:SocialLoginAutomaticCode:Loaded',function(event){
    var el = event.detail.el,
        cloneNode = event.detail.cloneNode; 
      if (Flits(el).attr('id') == 'create_customer') {
        Flits('.create-an-account .page-header').after(cloneNode);
        Flits(cloneNode).after(Flits.SocialLogin.settings.social_login_or_html);
        Flits(cloneNode).before(Flits.SocialLogin.settings.social_login_continue_html);
      }
  })

}(Flits));
